import React, { useCallback } from 'react';
import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import { DashboardPage } from '../../ui/dashboard/DashboardPage';
import { Box } from '../../ui/layout/Box';
import { Tab, Tabs } from '../../ui/navigation/Tabs';
import { Typography } from '../../ui/typography/Typography';
import { hasAccessToBusinessStat } from '../../utils/accessService';
import { ymTrackFeedManagerPostsOpen, ymTrackFeedManagerStaticOpen } from '../../utils/metrika';
import { useTranslation } from '../../utils/useTranslation';
import { useCurrentUser } from '../users/useCurrentUser';
import { withBusinessAuthProtection } from '../withBusinessAuthProtection';

export const BusinessManagement = withBusinessAuthProtection(() => {
    const t = useTranslation();
    const { businessId } = useParams();
    const currentUser = useCurrentUser();
    const { pathname } = useLocation();
    const tabs = [
        {
            value: `/businesses/${businessId}/management`,
            label: 'Посты',
        },
        {
            value: `/businesses/${businessId}/management/statistic`,
            label: 'Сводка',
        },
    ];

    const onTabClick = useCallback(
        (value: string) => {
            if (value === `/businesses/${businessId}/management`) {
                ymTrackFeedManagerPostsOpen({
                    page: 'Управления постами',
                    userLogin: currentUser?.login,
                    businessId: currentUser?.profile?.publicId,
                });
            }
            if (value === `/businesses/${businessId}/management/statistic`) {
                ymTrackFeedManagerStaticOpen({
                    page: 'Управления постами',
                    userLogin: currentUser?.login,
                    businessId: currentUser?.profile?.publicId,
                });
            }
        },
        [currentUser?.login, currentUser?.profile?.publicId],
    );

    return (
        <DashboardPage key={businessId} pb={0}>
            <Typography variant="title1" weight="bold" mb={3} mt={2} px={2}>
                {t('Управление лентой')}
            </Typography>
            {hasAccessToBusinessStat(businessId, currentUser) && (
                <Box pb={2} width="100%">
                    <Tabs value={pathname} width="100%" onChange={onTabClick}>
                        {tabs.map((tabItem) => (
                            <Tab
                                key={tabItem.value}
                                as={Link}
                                width="50%"
                                replace
                                to={tabItem.value}
                                value={tabItem.value}
                                textDecoration="none"
                            >
                                <Typography
                                    color="inherit"
                                    variant="body"
                                    weight="medium"
                                    textAlign="center"
                                >
                                    {tabItem.label}
                                </Typography>
                            </Tab>
                        ))}
                    </Tabs>
                </Box>
            )}
            <Outlet />
        </DashboardPage>
    );
});
